import { Bell } from '@/ui/icons'
import { PageLayout } from '@/ui/layout'

export default function NotificationsPage() {
  return (
    <PageLayout>
      <div className="min-h-[60vh] flex flex-col items-center justify-center px-4">
        <div className="rounded-2xl bg-earth-100 dark:bg-earth-800 p-6 mb-4">
          <Bell className="h-16 w-16 text-earth-500 dark:text-muted-foreground" aria-hidden />
        </div>
        <h1 className="text-2xl font-semibold text-earth-900 dark:text-foreground mb-2">Notifications</h1>
        <p className="text-earth-600 dark:text-muted-foreground text-center">Coming soon</p>
      </div>
    </PageLayout>
  )
}
